<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-tags title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.organizations' | transloco}}</p>
            <p>{{'menu.descriptions.organizationSubscriptions' | transloco}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <form *ngIf="organizationDataLoaded && organizationForm" [formGroup]="organizationForm">
        <div class="grid mb-3">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="name">{{'attribute.name' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="name" id="name" pInputText type="text">
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="email">{{'attribute.email' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="email" id="email" pInputText type="text">
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.mailLanguage' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-dropdown
                [options]="languageOptions"
                [(ngModel)]="selectedLanguage"
                [ngModelOptions]="{standalone: true}"
                optionLabel="name"
                filterBy="name"
                styleClass="w-full dropdown-language"
              >
                <ng-template pTemplate="selectedItem">
                  <div class="flex align-items-center">
                    <i [class]="'flag-icon flag-icon-' + selectedLanguage.code"></i>
                    <p class="mb-0 ml-1 mt-1 p-0">{{selectedLanguage.name}}</p>
                  </div>
                </ng-template>
                <ng-template let-language pTemplate="item">
                  <div class="flex align-items-center">
                    <i [class]="'flag-icon flag-icon-' + language.code"></i>
                    <p class="mb-0 ml-1 mt-1 p-0">{{language.name}}</p>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="mailTimezone">{{'attribute.mailTimezone' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-dropdown
                [placeholder]="'select.timezone' | transloco"
                [options]="timeZoneOptions"
                [filter]="true"
                styleClass="w-full"
                id="mailTimezone"
                optionValue="name"
                optionLabel="name"
                formControlName="mailTimezone"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="additionalMails">{{'attribute.additionalMails' | transloco}}:</label>
              <i [pTooltip]="'misc.info.organizations.alarmNotificationMails' | transloco" class="pi pi-info-circle ml-2"></i>
            </div>
            <div class="col-12">
              <p-chips (onAdd)="validateEmail($event)" [(ngModel)]="additionalMails" [allowDuplicate]="false"
                       [ngModelOptions]="{standalone: true}"
                       [placeholder]="'insert.alarmNotificationMails' | transloco"
                       class="p-fluid" id="additionalMails" separator=",">
                <ng-template let-item pTemplate="item">
                  <i class="pi pi-inbox mr-2"></i> {{item}}
                </ng-template>
              </p-chips>
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="!organizationDataLoaded || organizationForm == null">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="name">{{'attribute.name' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="email">{{'attribute.email' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.mailLanguage' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.mailTimezone' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="additionalMails">{{'attribute.additionalMails' | transloco}}:</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>

        </div>
      </div>

      <div class="grid">
        <div class="col-12">
          <div class="form-field col-12">
            <label>{{'attribute.alarmSubscriptions' | transloco}}: </label>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-12">
        <div class="p-datatable p-component p-datatable-hoverable-rows">
          <p-table dataKey="alarmDefinitionUuid" [(first)]="first" [(rows)]="rows" [paginator]="true"
            [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [value]="organizationSubscriptions"
             styleClass="p-datatable-striped" [breakpoint]="'1200px'">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">
                  {{'attribute.name' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.sensor' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.condition' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.timer' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.organizationOwner' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.notificationType' | transloco}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-alarm>
              <tr *ngIf="this.organizationDataLoaded">
                <td>
                  <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                  {{alarm.alarmDefinitionName}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.sensor' | transloco}}</span>
                  {{alarm.deviceMeasurement}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.condition' | transloco}}</span>
                  {{this.operationsTranslation[alarm.operation]}} ({{ alarm.value}})
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.timer' | transloco}}</span>
                  {{alarm.timeWindow}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.organizationOwner' | transloco}}</span>
                  {{alarm.organizationOwner.name}} ({{alarm.organizationOwner.orgCode}})
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.notificationType' | transloco}}</span>
                  <button *ngIf="alarm.alarmNotificationType == null" class="display-no-notificate white-space-nowrap"
                    pButton type="button" icon="pi pi-times" iconPos="left"
                    [label]="this.notificationTypeTranslation['NONE']"
                    (click)="this.changeNotificationType(alarm)"></button>
                  <button *ngIf="alarm.alarmNotificationType === AlarmNotificationType.INSTANTANEOUS"
                    class="display-notificate white-space-nowrap" pButton type="button" icon="pi pi-send" iconPos="left"
                    [label]="this.notificationTypeTranslation[AlarmNotificationType.INSTANTANEOUS]"
                    (click)="this.changeNotificationType(alarm)"></button>
                  <button *ngIf="alarm.alarmNotificationType === AlarmNotificationType.AGGREGATED"
                    class="display-notificate white-space-nowrap" pButton type="button" icon="pi pi-clock"
                    iconPos="left" [label]="this.notificationTypeTranslation[AlarmNotificationType.AGGREGATED]"
                    (click)="this.changeNotificationType(alarm)"></button>
                </td>
              </tr>
              <tr *ngIf="!this.organizationDataLoaded">
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between"
                *ngIf="this.totalOrganizationSubscriptions == 0">
                {{'pagination.empty'
                | transloco}}</div>
              <div class="flex align-items-center justify-content-between"
                *ngIf="this.totalOrganizationSubscriptions > 0">
                {{'pagination.showing' | transloco}} {{first + 1}}
                {{'pagination.to' | transloco}} {{(first + rows) >= this.totalOrganizationSubscriptions ?
                this.totalOrganizationSubscriptions : (first +
                rows)}}
                {{'pagination.of' | transloco}} {{this.totalOrganizationSubscriptions}}
                {{(this.totalOrganizationSubscriptions > 1 ? 'pagination.entries' : 'pagination.entry') |
                transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div class="grid" *ngIf="organizationDataLoaded && organizationForm">
        <div class="col-12">
          <div class="mt-auto col-12">
            <div class="flex justify-content-between mt-4">
              <button [label]="'common.cancel' | transloco" [routerLink]="'/organizations/'" pButton
                class="p-button-danger" iconPos="right"></button>
              <p-button [label]="'common.save' | transloco" [loading]="persistingChanges"
                        [disabled]="!organizationForm?.valid"
                        (onClick)="checkEmailAndPersistChanges()" styleClass="p-button-primary"></p-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!organizationDataLoaded || organizationForm == null">
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
